import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://icropsia.com";

export default function Seo({ title, description }) {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
}
